import LoaderController from './loader.controller';
import { LoaderProps } from './loader.model';

const Loader = (props: LoaderProps) => {
  return <LoaderController {...props} />;
};

export default Loader;
